import { setupEntryPoint } from './setupEntryPoint';
import App from '@/layouts/candidate/AuthenticationLayout.vue';
import router from '@/routers';
import '../controllers';

setupEntryPoint(App, router);
